// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"_7PuMQ","tooltipTrigger":"T-aU6","tooltip":"SvFRn","infoIcon":"wfwGG","tooltipArrow":"_3h7XY"};